/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ level: NonNullable<unknown>, language: NonNullable<unknown> }} Matching_Score_Algorithm_Language_Requirement_Not_MetInputs */

const en_matching_score_algorithm_language_requirement_not_met = /** @type {(inputs: Matching_Score_Algorithm_Language_Requirement_Not_MetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Minimum ${i?.level} requirement not met in ${i?.language}`)
};

const de_matching_score_algorithm_language_requirement_not_met = /** @type {(inputs: Matching_Score_Algorithm_Language_Requirement_Not_MetInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mindestanforderung ${i?.level} in ${i?.language} nicht erfüllt`)
};

/**
* | output |
* | --- |
* | "Minimum {level} requirement not met in {language}" |
*
* @param {Matching_Score_Algorithm_Language_Requirement_Not_MetInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_algorithm_language_requirement_not_met = /** @type {((inputs: Matching_Score_Algorithm_Language_Requirement_Not_MetInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_Algorithm_Language_Requirement_Not_MetInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_algorithm_language_requirement_not_met(inputs)
	return en_matching_score_algorithm_language_requirement_not_met(inputs)
});